'use strict';

var entryFactory = require('../../../../factory/EntryFactory'),
    cmdHelper = require('../../../../helper/CmdHelper');
    function httpGet(theUrl)
    {
        var params = "somevariable=somevalue&anothervariable=anothervalue";
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.open( "GET", theUrl+"?"+params, false ); // false for synchronous request
        xmlHttp.send( null );
        return  JSON.parse(xmlHttp.responseText);
    
    }

module.exports = function(element, bpmnFactory, options, translate) {

  var getImplementationType = options.getImplementationType,
      getBusinessObject = options.getBusinessObject;

  var optionsDelegateOptions=[];
  var requestDelegate = httpGet('/work_order_type_creation/retrieveExternalServiceTask');

  requestDelegate.forEach(item => {
    optionsDelegateOptions.push({ value: item.value, name: item.name });
  });

  var SELECT_OPTIONS = optionsDelegateOptions;

  function isExternal(element) {
    return getImplementationType(element) === 'external';
  }

  // var topicEntry = entryFactory.textField({
  //   id: 'externalTopic',
  //   label: translate('Topic'),
  //   modelProperty: 'externalTopic',

  //   get: function(element, node) {
  //     var bo = getBusinessObject(element);
  //     return { externalTopic: bo.get('camunda:topic') };
  //   },

  //   set: function(element, values, node) {
  //     var bo = getBusinessObject(element);
  //     return cmdHelper.updateBusinessObject(element, bo, {
  //       'camunda:topic': values.externalTopic
  //     });
  //   },

  //   validate: function(element, values, node) {
  //     return isExternal(element) && !values.externalTopic ? { externalTopic: 'Must provide a value' } : {};
  //   },

  //   hidden: function(element, node) {
  //     return !isExternal(element);
  //   }

  // });


  var topicEntry = entryFactory.selectBox({
  
    id : 'externalTopic',
    label: translate('Topic'),
    selectOptions: SELECT_OPTIONS,
    modelProperty: 'externalTopic',

    get: function(element, node) {
      var bo = getBusinessObject(element);
      // var type = getImplementationType(element);
     //  var attr = getAttribute(type);
      // var label = getDelegationLabel(type);
      return {
       // externalTopic: bo.get(attr) ||'',
        externalTopic: bo.get('camunda:topic') 
      };
    },
    set: function(element, values, node) {
      var bo = getBusinessObject(element);
      var type = getImplementationType(element);
      //var attr = getAttribute(type);
      // var prop = {};
      // prop[attr] = values.delegate || '';
      return cmdHelper.updateBusinessObject(element, bo, {
        'camunda:topic': values.externalTopic
      });
    },

    validate: function(element, values, node) {
      return isExternal(element) && !values.externalTopic ? { externalTopic: 'Must provide a value' } : {};
    },

    hidden: function(element, node) {
      return !isExternal(element);
    }

  });

  return [ topicEntry ];

};
